import React from "react";
import { Waypoint } from "react-waypoint";
import Loading from "../../components/loading";
import debounce from "lodash/debounce";

class InfiniteScrolling extends React.Component {
    state = {
        loading: false
    };

    loadMore = debounce(() => {
        if (!this.state.loading) {
            this.setState({ loading: true });
            this.props
                .loadMore()
                .then(this.onLoaded)
                .catch(this.onLoaded);
        }
    }, 200);

    onEnter = () => {
        this.loadMore();
    };

    onLoaded = () => {
        this.setState({ loading: false });
    };

    render() {
        return (
            <div>
                <div className="clearfix">{this.props.elements}</div>
                {this.state.loading ? <Loading /> : null}
                <Waypoint onEnter={this.onEnter} />
            </div>
        );
    }
}

export default InfiniteScrolling;
